"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import CalendarControlled from "./CalendarControlled.js";
const CalendarUncontrolled = (props) => {
    const { onChange, defaultValue, range, ...controlledProps } = props;
    const [value, setValue] = React.useState(defaultValue || null);
    if (range) {
        return (_jsx(CalendarControlled, { range: true, ...controlledProps, value: value, onChange: (args) => {
                setValue(args.value);
                onChange?.(args);
            } }));
    }
    return (_jsx(CalendarControlled, { ...controlledProps, value: value, onChange: (args) => {
            setValue(args.value);
            onChange?.(args);
        } }));
};
CalendarUncontrolled.displayName = "CalendarUncontrolled";
export default CalendarUncontrolled;
